const trimUrl = (value) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

const getDefaultRuntimeWindow = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window;
};

const getDefaultEnv = () => {
  if (typeof process === 'undefined') {
    return {};
  }
  return process.env || {};
};

export const resolveApiBaseUrl = ({
  nativeApp = false,
  runtimeWindow = getDefaultRuntimeWindow(),
  env = getDefaultEnv(),
} = {}) => {
  const runtimeApiUrl = trimUrl(runtimeWindow?.__ENV__?.API_URL);
  if (runtimeApiUrl) {
    return runtimeApiUrl;
  }

  if (nativeApp) {
    return trimUrl(env.REACT_APP_MOBILE_API_URL) || trimUrl(env.REACT_APP_API_URL) || undefined;
  }

  return trimUrl(env.REACT_APP_API_URL) || undefined;
};
